import { render } from "./EditRecord.vue?vue&type=template&id=5c4a1e96&scoped=true"
import script from "./EditRecord.vue?vue&type=script&lang=js"
export * from "./EditRecord.vue?vue&type=script&lang=js"

import "./EditRecord.vue?vue&type=style&index=0&id=5c4a1e96&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4a1e96"]])

export default __exports__